import React, { useState } from "react";
import { Card, CardContent } from "./ui/card";
import { DraggableModal } from "./ui/draggable-modal";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./ui/table";
import { Button } from "./ui/button";
import { Ban, Edit, Loader2 } from "lucide-react";

function getRoleLabel(p) {
  const rl = String(p?.role || "").toLowerCase();
  if (rl === "mudur") return "Müdür";
  if (rl === "admin") return "Süper Admin";
  if (rl === "golge_admin") return "Başkan";
  if (rl === "mudur_yardimcisi") return "Müdür Yardımcısı";
  if (rl === "bolge_muhendisi") return "Bölge Mühendisi";
  if (rl === "formen") return "Formen";
  if (rl === "park_gorevlisi") return "Park Görevlisi";
  if (rl === "çim_ekibi") return "Çim Ekibi";
  return p?.role || "—";
}

export default function BlockedLoginDashboardCard({
  blockedPersonnel = [],
  onUnblock,
  onEditPerson,
  unblockLoginLoadingId,
  className = "",
}) {
  const [detailOpen, setDetailOpen] = useState(false);
  const list = Array.isArray(blockedPersonnel) ? blockedPersonnel : [];
  const sorted = list
    .slice()
    .sort((a, b) => (a.name || "").localeCompare(b.name || "", "tr"));

  return (
    <>
      <Card
        className={`bg-gradient-to-br from-orange-500 to-amber-600 border-orange-700 cursor-pointer transition-transform hover:scale-105 hover:shadow-lg ${className}`}
        onClick={() => setDetailOpen(true)}
      >
        <CardContent className="p-4">
          <div className="flex flex-col items-center text-center">
            <Ban className="h-8 w-8 text-white mb-2" />
            <p className="text-2xl font-bold text-white">{list.length}</p>
            <p className="text-xs text-orange-50 font-semibold">Engellenenler</p>
          </div>
        </CardContent>
      </Card>

      <DraggableModal
        isOpen={detailOpen}
        onClose={() => setDetailOpen(false)}
        title="Girişi engellenen hesaplar"
        subtitle={`Toplam ${list.length} hesap`}
        maxWidth="max-w-3xl"
      >
        <div className="overflow-x-auto -mx-1">
          {sorted.length === 0 ? (
            <p className="text-center text-gray-500 py-8">Şu an girişi engellenmiş hesap yok.</p>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Ad Soyad</TableHead>
                  <TableHead className="hidden sm:table-cell">Rol</TableHead>
                  <TableHead className="text-right w-[200px]">İşlem</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {sorted.map((p) => (
                  <TableRow key={p.id}>
                    <TableCell className="font-medium">{p.name || "—"}</TableCell>
                    <TableCell className="hidden sm:table-cell text-muted-foreground text-sm">
                      {getRoleLabel(p)}
                    </TableCell>
                    <TableCell className="text-right">
                      <div className="flex flex-wrap justify-end gap-2">
                        <Button
                          type="button"
                          variant="outline"
                          size="sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            onEditPerson?.(p);
                          }}
                        >
                          <Edit className="h-3.5 w-3.5 mr-1" />
                          Düzenle
                        </Button>
                        <Button
                          type="button"
                          size="sm"
                          className="bg-green-700 hover:bg-green-800"
                          disabled={unblockLoginLoadingId === p.id}
                          onClick={(e) => {
                            e.stopPropagation();
                            onUnblock?.(p.id);
                          }}
                        >
                          {unblockLoginLoadingId === p.id ? (
                            <>
                              <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" />
                              Kaldırılıyor
                            </>
                          ) : (
                            "Engeli kaldır"
                          )}
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </DraggableModal>
    </>
  );
}
